/** @jsx jsx */
import { cssMap, jsx } from '@atlaskit/css';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const sizeStyles = cssMap({
	small: {
		width: '16px',
		height: '16px',
	},
	medium: {
		width: '24px',
		height: '24px',
	},
	large: {
		width: '32px',
		height: '32px',
	},
	xlarge: {
		width: '48px',
		height: '48px',
	},
});

interface GoogleDriveIconGlyphProps extends CustomGlyphProps {
	ariaLabel?: string;
	size?: 'small' | 'medium' | 'large' | 'xlarge';
	testId?: string;
}

const GoogleDriveIconGlyph = ({ ariaLabel, testId, size }: GoogleDriveIconGlyphProps) => (
	<svg
		width="20"
		height="18"
		viewBox="0 0 20 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-testid={testId}
		aria-label={ariaLabel}
		css={[size && sizeStyles[size]]}
	>
		<path d="M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z" fill="#3777E3" />
		<path d="M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z" fill="#FFCF63" />
		<path d="M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z" fill="#11A861" />
	</svg>
);
/**
 * __GoogleDriveIcon__
 */
const GoogleDriveIcon = ({ label, testId }: IconProps) => (
	<GoogleDriveIconGlyph ariaLabel={label} testId={testId} />
);
export default GoogleDriveIcon;
